import axios from "axios";
import vue from "vue";
import store from '../store/index'
import get from '../api/get'
import { Toast } from "vant";
import { router } from "../router";


let isQa = /^(test|qa)-/.test(location.hostname);
// let axiosbaseURL = "//" + (isQa ? "qa-" : "") + "sns.zlongame.com";
let axiosbaseURL = "//sns" + (isQa ? "test" : "") + ".tentree-games.com/";
// let axiosbaseURL = isQa ?"//qa-sns.zlongame.com":"//sns.zlongame.com";
axios.defaults.timeout = 20000;
// axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";

axios.defaults.baseURL = axiosbaseURL;
axios.defaults.withCredentials = true;
// axios.defaults.baseURL = 'http://10.0.8.80:3000/mock/11/';
//79洪闯
// axios.defaults.baseURL = "http://10.0.8.93:9180/";
// axios.defaults.baseURL = "http://test-lt.zlongame.com:9180/";
//  axios.defaults.baseURL = "http://10.0.8.90:8080/";
//  axios.defaults.baseURL = "http://10.0.8.81:9180/";
// axios.defaults.baseURL = "http://123.56.179.196:9180/";

// http request 拦截器
axios.interceptors.request.use(
  (config) => {
    if (store.state.token) {
      //判断token是否存在
      config.headers.Authorization = store.state.token; //将token设置成请求头
    }
    config.headers['PD-DID'] = localStorage.getItem('uuid');

    // if(store.state.loginStatus==0 &&window.user.appkey == '1705460260139'&&config.baseURL.indexOf('account')==-1){
    //   axios.defaults.headers['PD-LOGIN-FLAG'] = 0
    // }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);
let wx_url = ''
// 响应拦截
axios.interceptors.response.use(
  response => {
    //判断登录状态
    // if (response.data.code == '2050') {
    //   if (store.state.wxProgram) {
    //     if (wx_url != '/pdapi/member/messageList' || wx_url == '') {
    //       if (response.config.url.includes('/pdapi/member/follow/')) {
    //         store.commit('changeLoginShow', true)

    //       }
    //       if (router.currentRoute.path === '/userPage' || router.currentRoute.path === '/messagePage' || response.config.url.includes('pdapi/topic/share/')) {
    //         return
    //       }
    //       if (response.config.url != '/pdapi/task/sign/reward') {
    //         store.commit('changeLoginShow', true)
    //       }
    //     }
    //     wx_url = response.config.url
    //   }
    //   else {
    //     // console.log(router, '000')
    //     if (response.config.url.includes('/pdapi/member/follow/')) {
    //       store.commit('changeLoginShow', true)

    //     }
    //     if (router.currentRoute.path === '/userPage' || router.currentRoute.path === '/messagePage' || response.config.url.includes('pdapi/topic/share/')) {
    //       return
    //     }
    //     if (response.config.url != '/pdapi/task/sign/reward') {
    //       store.commit('changeLoginShow', true)
    //     }
    //   }
    //   store.commit('changeLoginStatus', 0)
    // }
    //判断token是否失效
    store.commit('connectionChang', false)
    //判断微信登录码是否失效
    if (response.config.url == 'indexInfo' && response.data.code == '2900') {
      Toast('登录码已刷新，请重新登录')
      router.push('/xcxlogin')
      return response
    }


    // 刷新消息未读数
    if (response.config.url.indexOf('topics') != -1 && store.state.loginStatus) {
      setTimeout(() => {
        let messageObj = {
          type: 1,
          pageNo: 1,
          pageSize: 10,
        };
        get.messageList(messageObj).then((res) => {
          let data = res.data;
          if (data.code == 0) {
            store.commit("changeMessageNum", [
              data.data.unReadNumTotal,
              true,
            ]);
          }
        })
      })
    }

    function getEmjoy(params, name) {
      let imgclass = "";
      switch (store.state.gameType) {
        case 1://龙之国
          switch (params) {
            case "0":
              imgclass = "role";
              break;
            case "1":
              imgclass = "dragon";
              break;
            case "2":
              imgclass = "littleDragon";
              break;
            default:
              break;
          }
          break;
        case 2://钢岚
          imgclass = "gl/role";
          break;
        case 3://第七史诗
          imgclass = "dqss/role";
          break;
        default:
          break;
      }
      return `<img class='emjoy' src=https://media.zlongame.com/media/pictures/cn/community/img/emjoy/${imgclass}/${name}.png>`
    }

    //转换帖子列表接口内容
    if ((response.config.url.indexOf('detail') != -1 || response.config.url.indexOf('commentList') != -1) && response.data.code == 0) {
      let data = response.data.data
      if (response.config.url.indexOf('commentList') != -1) {
        data.forEach((item, index) => {
          item.content = item.content.replace(/\[[\u4E00-\u9FA5]{1,3}_[\u4E00-\u9FA5]{1,7}_(\d){1,2}_(\d{1,3})\]/g, function (a, b, c) {
            return getEmjoy(b, c)
          })
          if (item.replyCommentList) {
            item.replyCommentList.forEach((items, indexs) => {
              items.content = items.content.replace(/\[[\u4E00-\u9FA5]{1,3}_[\u4E00-\u9FA5]{1,7}_(\d){1,2}_(\d{1,3})\]/g, function (as, bs, cs) {
                return getEmjoy(bs, cs)
              })
            })
          }

        });
      } else {
        data.content = data.content.replace(/\[[\u4E00-\u9FA5]{1,3}_[\u4E00-\u9FA5]{1,7}_(\d){1,2}_(\d{1,3})\]/g, function (a, b, c) {
          return getEmjoy(b, c)
        })
      }

    }
    if (response.config.url.indexOf('replyList') != -1 && response.data.code == 0) {
      let data = response.data.data
      data.list.forEach((item, index) => {
        item.content = item.content.replace(/\[[\u4E00-\u9FA5]{1,3}_[\u4E00-\u9FA5]{1,7}_(\d){1,2}_(\d{1,3})\]/g, function (a, b, c) {
          return getEmjoy(b, c)
        })
      });
    }
    return response
  },
  err => {
    store.commit('connectionChang', true)
    return err
  }
)

function requestFN(method, url, data) {
  // 基础请求方法
  let obj = {
    method, // 请求的类型
    url, // 请求地址
    headers: {
      // ['PD-LOGIN-FLAG']: store.state.loginStatus == 0 && (store.state.gameType == 2 || store.state.gameType == 3) ? 0 : window.user.appkey == '1504685273578' ? '1504685273578' : 1
      ['PD-LOGIN-FLAG']: store.state.loginStatus == 0 ? 0 : 1
    }
  };
  if (method === "get") {
    if (data) {
      obj.params = data; // url后面带参数 如 https://echarts.baidu.com/examples/a?test="1"
    }
  } else if (method === "post") {
    obj.data = data; // data 带参数
  }
  // 返回axios的基础方法
  return axios(obj).then((r) => {
    return r; // 方法请求的数据
  });
}
export default requestFN;
let axiosbaseURL1
if (isQa) {
  axiosbaseURL1 = "//accounttest.zlongame.com:" + (location.href.indexOf('https') != -1 ? '9443' : '9080');//9080
} else {
  axiosbaseURL1 = "https://member.zlongame.com"
}
const instance = axios.create({
  baseURL: axiosbaseURL1,
  timeout: 30000,
})
// instance.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
export function http1(method, url, data, config) {
  // 基础请求方法
  let obj = {
    method, // 请求的类型
    url, // 请求地址
    headers: config
  };
  if (method === "get") {
    if (data) {
      obj.params = data; // url后面带参数 如 https://echarts.baidu.com/examples/a?test="1"
    }
  } else if (method === "post") {
    obj.data = data; // data 带参数
  }
  // 返回axios的基础方法
  return instance(obj).then((r) => {
    return r; // 方法请求的数据
  });
}

// let axiosbaseURL2 = `//seama-activity${isQa ? 'test' : ''}.sugarfungame.com/`
let axiosbaseURL2 = `//ma-activity${isQa ? 'test' : ''}.tentree-games.com/`

const gameInfoService = axios.create({
  baseURL: axiosbaseURL2,
  timeout: 30000,
})

gameInfoService.interceptors.response.use(
  response => {
    return response.data
  });
gameInfoService.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded";
export function http2(method, url, data, config) {
  // 基础请求方法
  let obj = {
    method, // 请求的类型
    url, // 请求地址
    headers: config
  };
  if (method === "get") {
    if (data) {
      obj.params = data; // url后面带参数 如 https://echarts.baidu.com/examples/a?test="1"
    }
  } else if (method === "post") {
    obj.data = data; // data 带参数
  }
  // 返回axios的基础方法
  return gameInfoService(obj).then((r) => {
    return r; // 方法请求的数据
  });
}